/**
 * O MENU da casca Marçal Sistema (`?ui=sistema`): os 9 módulos.
 *
 * [Bruno 2026-10-02] Reorganização aprovada: Início, Clientes, Fiscal, Notas
 * fiscais, Contábil, Documentos, Atendimento, Gestão e Sistema. As telas que
 * saem (Operação Hoje, Painel gerencial, Bandeja, Quadro de atendimento,
 * Apuração Simples Nacional, Últimas emitidas, Certificados antigo e o Controle
 * fiscal do Firebase) NÃO estão aqui: continuam respondendo pela URL até a
 * fase de redirecionamento, e só depois o código sai.
 *
 * Este arquivo pretende ser a fonte ÚNICA do menu: a busca ⌘K deve passar a
 * derivar dele quando a casca virar padrão (hoje existem três listas que não
 * batem: Sidebar.js, menuCrm.js e CommandPalette.js).
 *
 * `sep` abre uma seção dentro do módulo. `badge` é a chave de
 * `/painel/menu-badges`; `tom: 'critico'` pinta o contador de vermelho.
 */
// Validação (teste) dos balancetes: só Pablo, Thiago e Bruno (13/10/2026).
// O servidor confere a mesma lista (BALANCETE_VALIDACAO_USUARIOS).
export const EMAILS_VALIDACAO_BALANCETE = [
  'bruno@marcalcontabilidade.com.br', 'thiago@marcalcontabilidade.com.br', 'thgo.borges@gmail.com', 'pablohmarcal@gmail.com',
];

// Financeiro (cobrança, rotina, DRE): só Pablo, Daniele e Thiago (Bruno, 13/10/2026).
// O servidor confere a mesma lista (FINANCEIRO_USUARIOS).
export const EMAILS_FINANCEIRO = [
  'daniele@marcalcontabilidade.com.br', 'thiago@marcalcontabilidade.com.br', 'thgo.borges@gmail.com', 'pablohmarcal@gmail.com',
];

// Manutenção do sistema (tudo que é da Julia): SÓ o Pablo (Bruno, 14/10/2026).
// O servidor confere a mesma lista (JULIA_MANUTENCAO_EMAILS).
export const EMAILS_MANUTENCAO = ['pablohmarcal@gmail.com'];
// [Bruno 2026-10-27] Letícia Chamados é de ADM: aparece pra esta lista sem
// precisar ser liberada (o servidor repete a régua em LETICIA_EMAILS).
export const EMAILS_LETICIA = ['bruno@marcalcontabilidade.com.br', 'thgo.borges@gmail.com', 'pablohmarcal@gmail.com'];

export const MENU_SISTEMA = [
  // [Bruno 2026-10-10] "O menu está confuso e bagunçado" → prévia aprovada
  // ("faça o que ficar melhor e mais prático"). Regras desta versão:
  //  • cada tela aparece UMA vez. As visões por casa (Meu Contador, NivelOn,
  //    Folha) viraram ABAS dentro da tela (`ABAS_TELA` abaixo + as abas que
  //    Chamados e WhatsApp já têm), em vez de links repetidos no menu;
  //  • o técnico (integrações, saúde, auditoria) saiu do menu principal e mora
  //    na engrenagem do rodapé, só para administrador (`MENU_CONFIG`);
  //  • cada pessoa fixa as telas que mais usa em Favoritos (estrela no item);
  //  • `tambem` lista endereços antigos que continuam abrindo a mesma tela
  //    (só para o menu acender e o caminho no topo dizer onde a pessoa está).
  { chave: 'inicio', label: 'Início', icone: 'home', to: '/escritorio/inicio' },
  { chave: 'chat', label: 'Chat da equipe', icone: 'msg', to: '/escritorio/chat', badge: 'chat' },
  { chave: 'agenda', label: 'Agenda e reuniões', icone: 'calendar', to: '/escritorio/agenda' },
  {
    chave: 'clientes', label: 'Clientes', icone: 'users', grupo: 'Rotina contábil', badge: 'cadastros',
    itens: [
      { to: '/escritorio/clientes', label: 'Carteira de clientes' },
      { to: '/escritorio/empresa', label: 'Ficha da empresa' },
      { sep: 'Cadastro' },
      { to: '/escritorio/cadastros', label: 'Cadastros para aprovar', badge: 'cadastros' },
      { to: '/escritorio/pendencias-cadastrais', label: 'Pendências cadastrais' },
      { to: '/escritorio/transicao-clientes', label: 'Transição de clientes' },
      { sep: 'Contratos e societário' },
      { to: '/escritorio/contratos', label: 'Contratos' },
      { to: '/escritorio/societario', label: 'Societário' },
      { sep: 'Certificados e procurações' },
      { to: '/escritorio/controle-certificados', label: 'Certificados A1', tambem: ['/escritorio/certificados-nivelon'] },
      { to: '/escritorio/procuracoes-ecac', label: 'Procurações no e-CAC' },
    ],
  },
  {
    chave: 'fiscal', label: 'Fiscal', icone: 'calc',
    itens: [
      { sep: 'Obrigações' },
      { to: '/escritorio/controle-fiscal', label: 'Controle fiscal' },
      { to: '/escritorio/painel-obrigacoes', label: 'Painel de obrigações' },
      { to: '/escritorio/entregas-serpro', label: 'Vencimentos' },
      { to: '/escritorio/dctf', label: 'DCTFWeb 12 meses' },
      { sep: 'Apuração' },
      { to: '/escritorio/fechamento-simples', label: 'Fechamento Simples' },
      { to: '/escritorio/apuracao-presumido', label: 'Lucro Presumido' },
      { to: '/escritorio/apuracao-real', label: 'Lucro Real' },
      { sep: 'Escriturações' },
      { to: '/escritorio/reinf', label: 'EFD-Reinf' },
      { to: '/escritorio/efd-contribuicoes', label: 'EFD-Contribuições' },
      { sep: 'Simuladores' },
      { to: '/escritorio/apuracao', label: 'Comparar regimes' },
      { to: '/escritorio/simulador-reforma', label: 'Reforma tributária' },
    ],
  },
  {
    // [Bruno 2026-10-07] Fechamento, pró-labore e o Fator R num lugar só. Os
    // pedidos de folha do app são a aba "Folha" de Atendimento › Chamados.
    chave: 'folha', label: 'Folha', icone: 'briefcase',
    itens: [
      { to: '/escritorio/folha-clt', label: 'Folha de funcionários' },
      { to: '/escritorio/prolabore', label: 'Pró-labore de sócios' },
      { to: '/escritorio/folha-12m', label: 'Folha 12 meses e Fator R' },
    ],
  },
  {
    chave: 'notas', label: 'Notas fiscais', icone: 'receipt',
    itens: [
      { to: '/escritorio/notas', label: 'Controle de notas' },
      { to: '/escritorio/aprovacoes', label: 'Notas para aprovar' },
      { to: '/escritorio/relatorios', label: 'Relatórios de faturamento' },
      { sep: 'Emitir' },
      { to: '/escritorio/emitir-nota', label: 'Nota de serviço' },
      { to: '/escritorio/nfe-produto', label: 'NF-e de produto' },
      { to: '/escritorio/nfe-credenciamento', label: 'Credenciamento NF-e' },
      { to: '/escritorio/emitir-lote', label: 'Várias de uma vez' },
    ],
  },
  {
    chave: 'contabil', label: 'Contábil', icone: 'book',
    // Decisão do Bruno (13/10/2026): dois grupos bem separados. "Contábil · Cockpit" é o ERP
    // novo (livro próprio no plano da Receita); "Contábil · Domínio" é o que alimenta o Domínio.
    itens: [
      { sep: 'Contábil · Cockpit' },
      { to: '/escritorio/contabil/painel', label: 'Painel do mês' },
      { to: '/escritorio/contabil', label: 'Lançamentos e demonstrações' },
      { to: '/escritorio/imobilizado', label: 'Imobilizado e depreciação' },
      { to: '/escritorio/plano-contas', label: 'Plano de contas' },
      { to: '/escritorio/relatorios-contabeis', label: 'Relatórios contábeis' },
      { sep: 'Contábil · Domínio' },
      { to: '/escritorio/balancetes', label: 'Balancetes do mês (João)' },
      { to: '/escritorio/balancetes-status', label: 'Situação dos balancetes' },
      { to: '/escritorio/layouts-dominio', label: 'Layouts de importação' },
      { sep: 'COSEMS' },
      { to: '/escritorio/prestacao-cosems', label: 'Prestação de contas COSEMS' },
    ],
  },
  {
    chave: 'documentos', label: 'Documentos', icone: 'folder',
    itens: [
      { to: '/escritorio/documentos', label: 'Central de documentos' },
      { to: '/escritorio/drive-clientes', label: 'Drive dos clientes' },
      { sep: 'Certidões e declarações' },
      { to: '/escritorio/certidoes-lista', label: 'Certidões' },
      { to: '/escritorio/certidao', label: 'Emitir certidão' },
      { to: '/escritorio/declaracao', label: 'Declaração de faturamento' },
    ],
  },
  {
    chave: 'atendimento', label: 'Atendimento', icone: 'headset', grupo: 'Atendimento', badge: 'atendimento',
    itens: [
      { to: '/escritorio/chamados', label: 'Chamados', badge: 'chamados_vencidos', tom: 'critico', tambem: ['/escritorio/nivelon'] },
      { to: '/escritorio/whatsapp', label: 'WhatsApp', badge: 'whatsapp_casas' },
      // [Pablo 2026-10-22] Módulo da Onésia (clientes novos); restrito: a manutenção libera em Quem vê o quê.
      { to: '/escritorio/primeiro-contato', label: 'Primeiro contato (clientes novos)', restrito: true },
    ],
  },
  {
    // [Pablo 2026-10-20] "o menu começou a virar uma bagunça": as ferramentas da ANA
    // saíram do meio dos chamados e viraram um módulo próprio, logo abaixo.
    chave: 'ana', label: 'ANA', icone: 'bot',
    itens: [
      { to: '/escritorio/fila-ana', label: 'Para aprovar' },
      { to: '/escritorio/ana', label: 'Conversas' },
    ],
  },
  {
    // [Bruno 2026-10-08] Meu Contador e NivelOn "bem separados": o que é SÓ de
    // cada app mora aqui, uma seção para cada. Chamados, WhatsApp, clientes,
    // cadastros, certificados e documentos de cada casa são abas das telas gerais.
    chave: 'apps', label: 'Apps dos clientes', icone: 'apps', badge: 'app_erros',
    itens: [
      { sep: 'Meu Contador' },
      { to: '/escritorio/acesso-empresas', label: 'Acesso das empresas' },
      { to: '/escritorio/cliente-espelho', label: 'Ver como o cliente' },
      { to: '/escritorio/cliente-erros', label: 'Erros do app', badge: 'app_erros' },
      { sep: 'NivelOn' },
      { to: '/escritorio/nivelon-contas', label: 'Contas (buscar e excluir)' },
    ],
  },
  {
    // [Bruno 2026-10-13] Módulo financeiro do escritório. Some do menu de quem
    // não está na lista (o módulo inteiro, não só os itens).
    chave: 'financeiro', label: 'Financeiro', icone: 'wallet', grupo: 'Administração',
    itens: [
      { to: '/escritorio/financeiro?view=lote', label: 'Notas e cobranças do mês', soEmails: EMAILS_FINANCEIRO },
      { to: '/escritorio/financeiro', label: 'Cobranças', soEmails: EMAILS_FINANCEIRO },
      { to: '/escritorio/financeiro?view=contratos', label: 'Contratos', soEmails: EMAILS_FINANCEIRO },
      { to: '/escritorio/financeiro?view=rotina', label: 'Rotina de cobrança', soEmails: EMAILS_FINANCEIRO },
      { to: '/escritorio/financeiro?view=dre', label: 'DRE', soEmails: EMAILS_FINANCEIRO },
      { to: '/escritorio/financeiro?view=lancamentos', label: 'Receitas e despesas', soEmails: EMAILS_FINANCEIRO },
      { to: '/escritorio/financeiro?view=banco', label: 'Banco e Pix', soEmails: EMAILS_FINANCEIRO },
    ],
  },
  {
    // [Pablo 2026-10-21] "Central de atendimento na Administração, onde só o Pablo ou
    // quem ele autoriza consiga ver (...) deixe tudo separado, fácil de achar, e as
    // dashboards que não há necessidade de funcionários verem". Item `restrito`:
    // só a manutenção vê, até ser liberado em "Quem vê o quê" (areaTestesService,
    // mesmo catálogo das telas de teste; o servidor barra as APIs das telas `servidor`).
    chave: 'administracao', label: 'Administração', icone: 'shield', grupo: 'Administração',
    itens: [
      { sep: 'Atendimento' },
      { to: '/escritorio/central-atendimento', label: 'Central de atendimento', tambem: ['/escritorio/tv-empresas'], restrito: true },
      { to: '/escritorio/avisos-clientes', label: 'Comunicados aos clientes', restrito: true },
      { to: '/escritorio/aviso-ios27', label: 'Aviso iOS 27 (WhatsApp)', restrito: true },
      { sep: 'ANA (configuração)' },
      { to: '/escritorio/ana-fluxo', label: 'Fluxo de atendimento', restrito: true },
      { to: '/escritorio/ana-conhecimento', label: 'Base de conhecimento', restrito: true },
      { to: '/escritorio/ana-casa', label: 'Valores e processos da casa', restrito: true },
      { to: '/escritorio/ana-triagem', label: 'O que ela responde', restrito: true },
      { to: '/escritorio/ana-simulacao', label: 'Simulação e aprendizado', restrito: true },
      { to: '/escritorio/ana-desempenho', label: 'Desempenho diário da ANA', restrito: true },
      { to: '/escritorio/ana-metricas', label: 'Métricas da ANA', restrito: true },
      { sep: 'Painéis' },
      { to: '/escritorio/performance-equipe', label: 'Performance da equipe', restrito: true },
      { to: '/escritorio/pontos-bonus', label: 'Pontos e bônus', restrito: true },
      { to: '/escritorio/jornada-clientes', label: 'Jornada dos clientes', restrito: true },
      { to: '/escritorio/parceiros-comerciais', label: 'Parceiros comerciais', restrito: true },
      { to: '/escritorio/aparelhos-clientes', label: 'Aparelhos dos clientes', restrito: true },
      { to: '/escritorio/nivelon-painel', label: 'NivelOn: painel e relatório', restrito: true },
      { to: '/escritorio/projetos', label: 'Projetos', restrito: true },
      { sep: 'Sistema' },
      { to: '/escritorio/manutencao', label: 'Manutenção (Julia)', soEmails: EMAILS_MANUTENCAO },
      { to: '/escritorio/white-label', label: 'White label (marcas)', wl: true }, // manutenção + quem o Pablo liberar
      { to: '/escritorio/acessos', label: 'Quem vê o quê', soEmails: EMAILS_MANUTENCAO },
    ],
  },
  {
    // [Pablo 2026-10-20] "as partes de teste estão juntas do operacional": tudo que é
    // teste ou homologação mora aqui, no fim, numa área própria e mais apagada.
    chave: 'testes', label: 'Testes', icone: 'flask', grupo: 'Área de testes', area: 'testes',
    // [Pablo 2026-10-20] "teste apenas eu posso ver": `teste: true` aparece só pra
    // manutenção (EMAILS_MANUTENCAO) ou pra quem ele liberar na tela Manutenção
    // (GET /api/area-testes/minhas). O catálogo do servidor (areaTestesService) repete estas rotas.
    itens: [
      { to: '/escritorio/testar-agente', label: 'Testar a ANA', teste: true },
      { to: '/escritorio/leticia-chamados', label: 'Letícia Chamados', teste: true, tambemEmails: EMAILS_LETICIA },
      { to: '/escritorio/certificado-compra', label: 'Compra de certificado', teste: true },
      { to: '/escritorio/balancetes-validacao', label: 'Validação dos balancetes', teste: true },
    ],
  },
];

/** Engrenagem do rodapé: só administrador. Fora do menu principal de propósito. */
export const MENU_CONFIG = {
  chave: 'config', label: 'Configurações', icone: 'gear',
  itens: [
    { sep: 'Integrações' },
    { to: '/escritorio/integra-contador', label: 'Integra Contador' },
    { to: '/escritorio/certificado-serpro', label: 'Certificado SERPRO' },
    { to: '/escritorio/consumo-serpro', label: 'Consumo SERPRO' },
    { to: '/escritorio/dominio', label: 'API Domínio' },
    { to: '/escritorio/joao', label: 'Robô do Domínio' },
    { sep: 'WhatsApp' },
    { to: '/escritorio/nivelon-whatsapp', label: 'Conectar WhatsApp da NivelOn' },
    { to: '/escritorio/whatsapp-importar', label: 'Importar conversas antigas' },
    { sep: 'Saúde do sistema' },
    { to: '/escritorio/observabilidade', label: 'Painel de saúde' },
    { to: '/escritorio/saude-crons', label: 'Rotinas automáticas' },
    { to: '/escritorio/motor-nf', label: 'Emissão de notas (diagnóstico)' },
    { to: '/escritorio/performance', label: 'Velocidade do sistema' },
    { to: '/escritorio/reports', label: 'Problemas reportados' },
    { sep: 'Acessos e regras' },
    { to: '/escritorio/equipe', label: 'Equipe e acessos' },
    { to: '/escritorio/guias-drive-nomenclatura', label: 'Nomes das guias no Drive' },
    { to: '/escritorio/audit', label: 'Auditoria' },
    { to: '/escritorio/mapa', label: 'Mapa do sistema' },
  ],
};

/**
 * Abas mostradas no topo da tela (pelo layout) para as telas que antes tinham
 * um link por casa no menu. Cada aba é só um endereço que já existia: nenhuma
 * tela mudou por dentro. Chamados e WhatsApp têm as abas deles na própria tela.
 */
export const ABAS_TELA = [
  { abas: [['Todos', '/escritorio/clientes'], ['Meu Contador', '/escritorio/clientes?origem=meu_contador'], ['NivelOn', '/escritorio/clientes?origem=nivelon'], ['Marcas', '/escritorio/clientes?origem=marcas']] },
  { abas: [['Escritório e Meu Contador', '/escritorio/cadastros'], ['NivelOn', '/escritorio/cadastros?origem=nivelon']] },
  { abas: [['Todos', '/escritorio/pendencias-cadastrais'], ['Meu Contador', '/escritorio/pendencias-cadastrais?origem=meu_contador'], ['NivelOn', '/escritorio/pendencias-cadastrais?origem=nivelon']] },
  { abas: [['Escritório e Meu Contador', '/escritorio/controle-certificados'], ['NivelOn', '/escritorio/certificados-nivelon']] },
  { abas: [['Escritório e Meu Contador', '/escritorio/documentos'], ['NivelOn', '/escritorio/documentos?origem=nivelon']] },
  // [Bruno 2026-10-11] Controle fiscal separado por casa.
  { abas: [['Todos', '/escritorio/controle-fiscal'], ['Meu Contador', '/escritorio/controle-fiscal?origem=meu_contador'], ['NivelOn', '/escritorio/controle-fiscal?origem=nivelon']] },
];

/** As abas da tela atual (ou null) e qual está ativa. PURA. */
export function abasDaTela(pathname, search = '') {
  for (const g of ABAS_TELA) {
    // a aba mais específica primeiro: `?origem=nivelon` ganha da aba sem filtro
    const ordem = g.abas.map((a, i) => [a, i]).sort((x, y) => y[0][1].length - x[0][1].length);
    for (const [[, to], i] of ordem) {
      if (casaItem(to, pathname, search)) return { abas: g.abas, ativa: i };
    }
  }
  return null;
}

// Os dois papéis restritos veem um item só, como no menu de hoje (Sidebar.js):
// oferecer porta que o servidor recusa ensina a desconfiar da ferramenta.
export const MENU_PARCEIRO = [{
  chave: 'atendimento', label: 'Societário', icone: 'msg', grupo: 'Societário', badge: 'chamados',
  itens: [{ to: '/escritorio/chamados', label: 'Chamados' }],
}];
export const MENU_DP = [{
  chave: 'atendimento', label: 'Folha', icone: 'msg', grupo: 'Departamento pessoal', badge: 'chamados',
  itens: [{ to: '/escritorio/chamados?fila=folha', label: 'Solicitações' }, { to: '/escritorio/folha-clt', label: 'Folha de funcionários' }, { to: '/escritorio/chat', label: 'Chat da equipe', badge: 'chat' }, { to: '/escritorio/agenda', label: 'Agenda e reuniões' }],
}];

// [Pablo 2026-10-22] O login do Primeiro contato (a Onésia) vê só o módulo dela.
export const MENU_PRIMEIRO_CONTATO = [{
  chave: 'atendimento', label: 'Primeiro contato', icone: 'msg', grupo: 'Clientes novos',
  // [Pablo 2026-10-26] Só NivelOn: um item, a tela tem as abas dentro.
  itens: [
    { to: '/escritorio/primeiro-contato?casa=nivelon', label: 'WhatsApp da NivelOn' },
  ],
}];

export function menuDoPapel(papel, email, testesLiberados = [], wlLiberado = false) {
  if (papel === 'primeiro_contato') return MENU_PRIMEIRO_CONTATO;
  if (papel === 'parceiro_societario') return MENU_PARCEIRO;
  if (papel === 'departamento_pessoal') return MENU_DP;
  // Item com `soEmails` só aparece pra quem está na lista (o servidor também barra).
  // Item `teste` só pra manutenção ou se a rota foi liberada pra esta pessoa.
  const e = String(email || '').toLowerCase();
  const liberados = Array.isArray(testesLiberados) ? testesLiberados : [];
  const tem = (it) => {
    if (it.soEmails && !it.soEmails.includes(e)) return false;
    const porLista = Array.isArray(it.tambemEmails) && it.tambemEmails.includes(e);
    if ((it.teste || it.restrito) && !porLista && !EMAILS_MANUTENCAO.includes(e) && !liberados.includes(it.to)) return false;
    if (it.wl && !EMAILS_MANUTENCAO.includes(e) && !wlLiberado) return false;
    return true;
  };
  // Módulo que ficou sem nenhum item (ex.: Financeiro pra quem não está na lista) some inteiro.
  return MENU_SISTEMA.map((m) => (m.itens ? { ...m, itens: m.itens.filter(tem) } : m))
    .filter((m) => !m.itens || m.itens.some((it) => it.to));
}

/**
 * Item com consulta (`/escritorio/chamados?fila=folha`) casa só no mesmo
 * caminho E com todos os parâmetros dele na URL atual. PURA.
 */
export function casaItem(to, pathname, search = '') {
  const [caminho, consulta] = String(to).split('?');
  if (!consulta) return pathname === caminho || pathname.startsWith(caminho + '/');
  if (pathname !== caminho) return false;
  const atual = new URLSearchParams(search || '');
  return [...new URLSearchParams(consulta)].every(([k, v]) => atual.get(k) === v);
}

/** Algum item com consulta casa a URL atual? Aí o item sem consulta do mesmo caminho não acende. */
export function consultaCasa(pathname, search, menu = MENU_SISTEMA) {
  return menu.some((m) => (m.itens || []).some((it) => it.to && it.to.includes('?') && casaItem(it.to, pathname, search)));
}

/**
 * Onde a rota está no menu: `{ modulo, item }`. PURA.
 * Casa pelo `to` mais LONGO, senão `/escritorio/notas` roubaria
 * `/escritorio/notas/draft/12` e `/escritorio/ana` roubaria `/ana-metricas`.
 * O item com consulta conta o tamanho inteiro: a fila de folha
 * (`?fila=folha`) ganha da lista geral de Chamados.
 */
export function localizarRota(pathname, menu = MENU_SISTEMA, search = '') {
  let melhor = { modulo: null, item: null };
  let tamanho = -1;
  for (const m of menu) {
    const alvos = m.to ? [{ to: m.to, label: m.label }] : (m.itens || []);
    for (const it of alvos) {
      if (!it.to) continue;
      for (const to of [it.to, ...(it.tambem || [])]) {
        if (casaItem(to, pathname, search) && to.length > tamanho) {
          melhor = { modulo: m, item: m.to ? null : it };
          tamanho = to.length;
        }
      }
    }
  }
  return melhor;
}
